import { render, staticRenderFns } from "./RenameModuleModal.vue?vue&type=template&id=f30072ba&scoped=true"
import script from "./RenameModuleModal.vue?vue&type=script&lang=js"
export * from "./RenameModuleModal.vue?vue&type=script&lang=js"
import style0 from "./RenameModuleModal.vue?vue&type=style&index=0&id=f30072ba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f30072ba",
  null
  
)

export default component.exports